import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';

const DiscountsSelector = (state: RootState) => state.discounts;

export const selectAllDiscounts = createSelector(
  DiscountsSelector,
  (state) => state.items,
);

export const selectDiscountsPendingStatus = createSelector(
  DiscountsSelector,
  (state) => state.isPending,
);

export const selectDiscountValidationMessage = createSelector(
  DiscountsSelector,
  (state) => state.validationResult,
);
